const customDispatchEvents = {
	EmailBouncedCTAViewed: "UpdateEmailBouncedCTAViewed",
};

export default customDispatchEvents;
